import React, { useEffect, useState } from 'react'
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchLocation from "../../../searchLocation/searchLocation";
import FileUpload from "../../../FileUploads/FileUpload";
import NewFileUploader from '../../../NewFileUploader/NewFileUploader.js';
import { getLeadById } from "../../../../service/Lead/action";
import {
  checkAgreementVerifiedRequest,
  newBankDetailsRequest,
  ucdAgreementNotificationRequest
} from "../../../../service/Dealer/action";

const Save = ({
  match,
  history,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  ucdById,
  ucdDetails = [],
  locationPinCode,
  pincodeData,
  ucdSave,
  ucsSaveResponse = [],
  locationCity,
  locationZone,
  locationArea,
  cities = [],
  zones = [],
  areas = [],
  getLeadById,
  leadById,
  newBankDetailsRequest,
  newBankDetailsResponse = [],
  ucdAgreementNotificationRequest,
  ucdAgreementNotificationResponse = [],
  checkAgreementVerifiedRequest,
  checkAgreementVerifiedResponse = []
}) => {
  const [inputList, setInputList] = useState([{
    business_name: '',
    owner_name: '',
    dealer_pan_no: '',
    aadhar_no: '',
    gst_no: '',
    msme_certificate: '',
    current_location: '',
    registration_email: '',
    registration_phone_no: '',
    bank_name: '',
    account_no: '',
    ifsc_code: '',
    branch_name: '',
    upload_cancelled_cheque: '',
    selfie_with_dsa: '',
    dealer_images_1: '',
    dealer_images_2: '',
    dealer_images_3: '',
    dealer_images_4: '',
    gst_certificate_photo: '',
    pan_card_photo: '',
    msme_declaration_photo: '',
    msme_certificate_photo: '',
    gst_registration: '',
    pincode: '',
    geo_city_id: '',
    geo_state_id: '',
    city_id: '',
    state_id: '',
    area_id: '',
    account_type: '',
    zone_id: '',
    msme_no: '',
    is_custom_location: '',
    agreement_certificate: "",
    office_address_same_as_registration: '',
    office_geo_city_id: '',
    office_geo_state_id: '',
    office_zone_id: '',
    office_city_id: '',
    office_location: '',
  }]);

  const [isLoading, setIsLoading] = useState(false)
  const [mapLocation, setMapLocation] = useState({
    address: 'Delhi',
    lat: 0,
    lng: 0,
  });
  const islatlng = useLatLng();
  const [isAllow, setIsAllow] = useState(false);
  const [long, setLong] = useState('')
  const [lat, setLat] = useState('')
  const [officeLong, setOfficeLong] = useState('')
  const [officeLat, setOfficeLat] = useState('')
  const [pincodeValue, setPincodeValue] = useState('')
  const [pincode, setPincode] = useState([]);
  const [officePincodeData, setOfficePincodeData] = useState([]);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [haveDealerLocation, setHaveDealerLocation] = useState('');
  const [customerBankName, setCustomerBankName] = useState('')
  const [officePincode, setOfficePincode] = useState('');
  const [optOfficeOption, setOfficeOptOption] = useState({
    address2: '',
    currentLocation: '',
  });

  const [optOption, setOptOption] = useState({
    address2: '',
    currentLocation: '',
  });
  const [locationSearchId, setLocationSearchId] = useState('');
  const [confirmAadharCard, setConfirmAadharCard] = useState('');
  const [agreementType, setAgreementType] = useState(0);
  const [phoneNo, setPhoneNo] = useState('');
  const [verifyText, setVerifyText] = useState("Check For Verification");
  const [userId, setUserId] = useState('');

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      setUserId(window.localStorage.user_id);
      await ucdById(match?.params?.ucd_id)
      await locationCity()
      await newBankDetailsRequest()
      if (match?.params?.lead_id) {
        await getLeadById(match?.params?.lead_id)
      }
      setIsLoading(false)
    })()
  }, [])

  const handleInput = (val, index) => {
    const list = [...inputList]
    list[0][index] = val
    setInputList(list)
  }


  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: 'Delhi6',
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  useEffect(() => {
    if (parseInt(ucsSaveResponse?.status) === 200) {
      toast.success(ucsSaveResponse?.message)
      setTimeout(() => {
        window.location.href = 'ucd-dealer-list'
      }, 1000)
    } else if (ucsSaveResponse?.status !== undefined && ucsSaveResponse?.status !== 200) {
      toast.error(ucsSaveResponse?.message)
      setDisableSubmitButton(false)
    }
  }, [ucsSaveResponse])


  const handleSubmit = async (e) => {
    e.preventDefault()
    let requestParams = inputList[0]
    requestParams['lat'] = islatlng?.lat
    requestParams['long'] = islatlng?.lng
    requestParams['registration_phone_no'] = ucdDetails?.data?.registration_mobile_no
    requestParams['gst_no'] = requestParams['gst_no'] ?? ucdDetails?.data?.dealer_gst_no
    requestParams['office_pincode'] = officePincode;
    requestParams['office_geo_city_id'] = officePincodeData?.geo_city_id;
    requestParams['office_geo_state_id'] = officePincodeData?.geo_state_id;
    requestParams['id'] = match?.params?.ucd_id
    requestParams['office_lat'] = officeLat;
    requestParams['office_long'] = officeLong;
    if (!requestParams['site_longitude']) {
      requestParams['site_longitude'] = officeLong;
    }

    if (!requestParams['site_latitude']) {
      requestParams['site_latitude'] = officeLat;
    }

    if (requestParams['office_address_same_as_registration'] === 'No') {
      requestParams['pincode'] = pincodeValue
      requestParams['geo_city_id'] = pincode?.geo_city_id
      requestParams['geo_state_id'] = pincode?.geo_state_id
    }

    if (requestParams['bank_name'] === 'Other') {
      requestParams['bank_name'] = customerBankName;
    }

    if (requestParams['aadhar_no'].length < 12 || requestParams['aadhar_no'].length > 12) {
      toast.error("Aadhar no must be 12 digit")
      return false;
    }

    if (ucdDetails?.data && ucdDetails?.data?.channel_type === 'DSA' && !requestParams['selfie_with_dsa']) {
      toast.error("Selfie is required with DSA")
      return false;
    } else if (ucdDetails?.data?.channel_type !== 'DSA' &&
      (
        !requestParams['dealer_images_1'] ||
        !requestParams['dealer_images_2'] ||
        !requestParams['dealer_images_3'] ||
        !requestParams['dealer_images_4']
      )
    ) {
      toast.error("Please upload all 4 dealer images.");
      return false;
    }

    if(!requestParams['office_location']) {
      toast.error("Please select the office location.");
      return false;
    }


    if (!requestParams['gst_certificate_photo'] && ucdDetails?.data?.organization_type === 'Company') {
      toast.error("GST certificate photo is missing.")
      return false;
    }

    if (!requestParams['pan_card_photo']) {
      toast.error("Pan card photo is missing.")
      return false;
    }

    if (!requestParams['msme_declaration_photo'] && !requestParams['msme_certificate_photo']) {
      toast.error("MSME declaration or certificate photo is missing.")
      return false;
    }

    if (agreementType === 2 && verifyText !== 'Verified') {
      toast.error("E-signed agreement is not verified!")
      return false;
    }

    if (parseInt(confirmAadharCard) !== parseInt(requestParams['aadhar_no'])) {
      toast.error("aadhar card doesn't matched!");
      return false;
    }

    // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
    // return
    if (requestParams['lat'] == null || requestParams['long'] == null) {
      toast.error('Please enable your location');
      return false
    }

    // console.log("requestParamsrequestParams " + JSON.stringify(requestParams))
    // return
    setIsLoading(true)
    setDisableSubmitButton(true)
    const res = await ucdSave(requestParams)
    setIsLoading(false)
  }

  useEffect(() => {
    (async () => {
      if (pincodeValue === '') {
        return false
      }
      await locationPinCode(pincodeValue)
    })();
  }, [pincodeValue])

  useEffect(() => {
    (async () => {
      if (officePincode === '') {
        return false
      }
      await locationPinCode(officePincode)
    })();
  }, [officePincode])

  useEffect(() => {
    if (pincodeData && pincodeData.length > 0) {
      if (locationSearchId === 'registration_address') {
        setPincode([])
        setPincode(pincodeData[0])
      } else {
        setOfficePincodeData(pincodeData[0])
      }

    }
  }, [pincodeData])

  const handleCurrentLocationBlur = (latlng = null) => {
    if (latlng !== null && latlng !== undefined) {
      setLong(latlng?.lng)
      setLat(latlng?.lat)
      handleInput(latlng?.lng, 'site_longitude')
      handleInput(latlng?.lat, 'site_latitude')
    }
  };

  const handleCurrentLocationChange = (value) => {
    setLocationSearchId('registration_address');
    setOptOption({ ...optOption, currentLocation: value });
    handleInput(value, 'current_location')
  };

  const handleCurrentOfficeLocationBlur = (latlng = null) => {
    if (latlng !== null && latlng !== undefined) {
      setOfficeLong(latlng?.lng)
      setOfficeLat(latlng?.lat)
    }
  };

  const handleCurrentOfficeLocationChange = (value) => {
    setLocationSearchId('office_address');
    setOfficeOptOption({ ...optOfficeOption, currentLocation: value });
    handleInput(value, 'office_location')
  };

  const [isInputError, setIsInputError] = useState({
    latError: false,
    longError: false,
    pinError: false,
    crl: false,
    isPinNotFound: false,
  });

  const handleZone = async (city_id) => {
    handleInput(city_id, 'city_id');
    setIsLoading(true)
    await locationZone(city_id)
    setIsLoading(false)
  }

  const handleArea = async (zone_id) => {
    handleInput(zone_id, 'zone_id');
    setIsLoading(true)
    await locationArea(zone_id)
    setIsLoading(false)
  }

  const handleOfficeZone = async (city_id) => {
    handleInput(city_id, 'office_city_id');
    setIsLoading(true)
    await locationZone(city_id)
    setIsLoading(false)
  }

  const handleOfficeArea = async (zone_id) => {
    handleInput(zone_id, 'office_zone_id');
    setIsLoading(true)
    await locationArea(zone_id)
    setIsLoading(false)
  }

  useEffect(() => {
    if (ucdDetails?.data) {
      if (ucdDetails?.data?.account_id) {
        window.location.href = 'ucd-dealer-list'
      }

      if (ucdDetails?.data?.business_name) {
        handleInput(ucdDetails?.data?.business_name, 'business_name')
      }

      if (ucdDetails?.data?.owner_name) {
        handleInput(ucdDetails?.data?.owner_name, 'owner_name')
      }

      if (ucdDetails?.data?.dealer_gst_no) {
        handleInput('Yes', 'gst_registration')
      }

      if (ucdDetails?.data?.aadhar_no) {
        handleInput(ucdDetails?.data?.aadhar_no, 'aadhar_no');
        setConfirmAadharCard(ucdDetails?.data?.aadhar_no)
      }

      if (ucdDetails?.data?.registration_mobile_no) {
        setPhoneNo(ucdDetails?.data?.registration_mobile_no)
        handleInput(ucdDetails?.data?.registration_mobile_no, 'registration_mobile_no');
      }
    }
  }, [ucdDetails])

  useEffect(() => {
    if (leadById?.data && leadById?.data?.meta_data[0]) {
      setOptOption({
        address2: '',
        currentLocation: leadById?.data?.address,
      })
      setPincode(leadById?.data?.meta_data[0]?.pincode)
      setPincodeValue(leadById?.data?.meta_data[0]?.pincode)
      handleInput(leadById?.data?.meta_data[0]?.pincode, 'pincode')
      setHaveDealerLocation("No")
      handleInput(leadById?.data?.number, 'registration_phone_no')
      handleInput(leadById?.data?.email, 'registration_email')
      handleInput(leadById?.data?.address, 'current_location')
      if (!inputList[0]?.owner_name) {
        handleInput(leadById?.data?.poc_name, 'owner_name')
      }
      if (!inputList[0]?.registration_email) {
        handleInput(leadById?.data?.business_name, 'account_name')
      }
    }
  }, [leadById])

  const handleAgreementNotify = async () => {
    if (!inputList[0]['aadhar_no']) {
      toast.error("Please enter aadhar no!");
      return;
    }

    if (parseInt(confirmAadharCard) !== parseInt(inputList[0]['aadhar_no'])) {
      toast.error("Aadhar card doesn't matched!");
      return false;
    }

    if (!inputList[0]['business_name']) {
      toast.error("Business name is required!");
      return false;
    }

    setVerifyText("Check For Verification");
    setIsLoading(true);
    await ucdAgreementNotificationRequest({
      phone_no: phoneNo, id: match?.params?.ucd_id, business_name: inputList[0]['business_name'],
      aadhar_no: inputList[0]['aadhar_no'],
    });
    setIsLoading(false);
  }

  useEffect(() => {
    if (parseInt(ucdAgreementNotificationResponse?.status) === 200) {
      toast.success(ucdAgreementNotificationResponse?.message);
    } else if (ucdAgreementNotificationResponse?.status !== undefined && ucdAgreementNotificationResponse?.status !== 200) {
      toast.error(ucdAgreementNotificationResponse?.message);
      setDisableSubmitButton(false);
    }
  }, [ucdAgreementNotificationResponse]);


  const handleIsAgreementEsigned = async () => {
    if (!inputList[0]['aadhar_no']) {
      toast.error("Please enter aadhar no!");
      return;
    }
    setIsLoading(true);
    await checkAgreementVerifiedRequest(match?.params?.ucd_id, inputList[0]['aadhar_no'], inputList[0]?.business_name);
    setIsLoading(false);
  }

  useEffect(() => {
    if (parseInt(checkAgreementVerifiedResponse?.status) === 200) {
      toast.success(checkAgreementVerifiedResponse?.message);
      setVerifyText("Verified");
    } else if (checkAgreementVerifiedResponse?.status !== undefined && checkAgreementVerifiedResponse?.status !== 200) {
      toast.error(checkAgreementVerifiedResponse?.message);
      setDisableSubmitButton(false);
    }
  }, [checkAgreementVerifiedResponse]);

  useEffect(() => {
    if (confirmAadharCard.length > 0 && confirmAadharCard !== inputList[0]['aadhar_card']) {
      // console.log(confirmAadharCard);
    }
  }, [confirmAadharCard]);
  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header
              title={'Dealer Details'}
              history={history}
            />
            {/*BODY*/}
            <div>
              <div className="container-fluid">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                        {/*<h1 className="h3 mb-0 text-black-100">Fast Tag Toll</h1>*/}
                      </div>
                      <div className="mb-4 bg-white"> {/*card*/}
                        <div className="hide card-header bg-lightGreen-active">
                          POC Details
                        </div>
                        <div className="card-body">
                          <div className="user">
                            <div className="form-group row">
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'business_name', e)
                                  }}
                                  value={inputList[0]?.business_name}
                                  required
                                />
                                <label
                                  className="large-label float-lb">
                                  Business Name <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'owner_name', e)
                                  }}
                                  value={inputList[0]?.owner_name}
                                  required
                                />
                                <label
                                  className="large-label float-lb">
                                  Owner Name <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'dealer_pan_no', e)
                                  }}
                                  value={(ucdDetails?.data && ucdDetails?.data?.dealer_pan_no) ?? ucdDetails?.data?.dealer_pan_no}
                                  required
                                  maxLength={10}
                                  minLength={10}
                                />
                                <label
                                  className="large-label float-lb">
                                  Dealer Pan No <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    handleInput(value, 'aadhar_no', e)
                                    e.target.value = value; // Update the input field with only numeric characters
                                  }}
                                  maxLength={12}
                                  minLength={12}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  onCopy={(e) => {
                                    e.preventDefault()
                                    return false;
                                  }}
                                  value={inputList[0]['aadhar_no']}
                                />
                                <label
                                  className="large-label float-lb">
                                  Aadhar No <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    setConfirmAadharCard(value)
                                    e.target.value = value; // Update the input field with only numeric characters
                                  }}
                                  value={confirmAadharCard}
                                  maxLength={12}
                                  minLength={12}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  onPaste={(e) => {
                                    e.preventDefault()
                                    return false;
                                  }}
                                  style={confirmAadharCard.length > 0 && confirmAadharCard !== inputList[0]['aadhar_no'] ? { borderColor: "red" } : {}}
                                />
                                <label
                                  className="large-label float-lb">
                                  Confirm Aadhar No <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 mt-1 float-field"
                                style={{ marginTop: "16px !important" }}>
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'gst_registration', e)
                                  }} required>
                                  <option value="">GST Registration</option>
                                  <option
                                    value="Yes"
                                    selected={ucdDetails?.data && ucdDetails?.data?.dealer_gst_no}>Yes
                                  </option>
                                  <option
                                    value="No">No
                                  </option>

                                </select>
                                <label className="large-label float-lb">
                                  GST Registration
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'gst_no', e)
                                  }}
                                  value={ucdDetails?.data && ucdDetails?.data?.dealer_gst_no ? ucdDetails?.data?.dealer_gst_no : inputList[0]['gst_no']}
                                  required={ucdDetails?.data && ucdDetails?.data?.organization_type === 'Company'}
                                  maxLength={15}
                                  minLength={15}
                                />
                                <label
                                  className="large-label float-lb">
                                  GST No
                                  {ucdDetails?.data && ucdDetails?.data?.organization_type === 'Company' &&
                                    <i
                                      className="bi bi-asterisk astrick-icon"></i>
                                  }
                                </label>
                              </div>

                              <SearchLocation
                                handleCurrentLocationBlur={handleCurrentOfficeLocationBlur}
                                isError={isInputError.crl}
                                value={optOfficeOption.currentLocation}
                                handleCurrentLocationChange={handleCurrentOfficeLocationChange}
                                label={"Office Location"}
                                setPincodeValue={setOfficePincode}
                                id={'officeAddress'}
                              />

                              {/* <div className="col-sm-6 mt-1 float-field"
                                                                 style={{marginTop: "16px !important"}}>
                                                                <select
                                                                    className="form-control form-control-user"
                                                                    onChange={(e) => {
                                                                        setHaveDealerLocation(e.target.value)
                                                                        handleInput(e.target.value, 'is_custom_location')
                                                                    }} required>
                                                                    <option value="">Do you have office location?
                                                                    </option>
                                                                    <option
                                                                        value="Yes"
                                                                        selected={haveDealerLocation === 'Yes'}>Yes
                                                                    </option>
                                                                    <option
                                                                        value="No"
                                                                        selected={haveDealerLocation === 'No'}>No
                                                                    </option>

                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Are you at the office location?
                                                                </label>
                                                            </div>
                                                            {haveDealerLocation === 'Yes' &&
                                                                <SearchLocation
                                                                    handleCurrentLocationBlur={handleCurrentOfficeLocationBlur}
                                                                    isError={isInputError.crl}
                                                                    value={optOfficeOption.currentLocation}
                                                                    handleCurrentLocationChange={handleCurrentOfficeLocationChange}
                                                                    label={"Office Location"}
                                                                    setPincodeValue={setOfficePincode}
                                                                    id={'officeAddress'}
                                                                />
                                                            } */}

                              {/* {haveDealerLocation === 'No' &&
                                                                <div className="col-md-6 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleInput(e.target.value, 'office_location')
                                                                           }}
                                                                           value={inputList[0]['office_location']}
                                                                           required
                                                                    />

                                                                    <label className="large-label float-lb">
                                                                        Office Location <i
                                                                        className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                            } */}
                              <div className="col-md-6 float-field mt-3">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    setOfficePincode(value)
                                    e.target.value = value;
                                  }}
                                  value={officePincode}
                                  required
                                  maxLength={6}
                                  minLength={6}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                />

                                <label className="large-label float-lb">
                                  Office Pincode <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-md-6 float-field mt-3">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(officePincodeData?.geo_city_id, 'office_geo_city_id')
                                  }}
                                  disabled
                                  value={officePincodeData?.city_name !== undefined ? officePincodeData?.city_name : ''}
                                  required
                                />

                                <label className="large-label float-lb">
                                  Geographical City <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-md-6 float-field mt-3">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(officePincodeData?.geo_state_id, 'office_geo_state_id')
                                  }}
                                  disabled
                                  value={officePincodeData?.state_name !== undefined ? officePincodeData?.state_name : ''}
                                  required
                                />

                                <label className="large-label float-lb">
                                  Geographical State <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 float-field mt-3">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleOfficeZone(e.target.value)
                                  }} required={true}>
                                  <option value="">Select City</option>
                                  {cities && cities.map((val) => {
                                    return (
                                      <option
                                        value={val?.id}>{val.name}</option>
                                    )
                                  })}
                                </select>
                                <label className="large-label float-lb">
                                  Office City <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 float-field mt-3">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => handleOfficeArea(e.target.value)}
                                  required={true}>
                                  <option value="">Select Zone</option>
                                  {zones.map((val) => {
                                    return (
                                      <option
                                        value={val?.id}>{val.name}</option>
                                    )
                                  })}
                                </select>
                                <label className="large-label float-lb">
                                  Office Zone <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 float-field mt-3">
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => handleInput(e.target.value, 'office_area_id')}
                                  required={true}>
                                  <option value="">Select Area/Sector</option>
                                  {areas && areas.map((val) => {
                                    return (
                                      <option
                                        value={val?.id}>{val.name}</option>
                                    )
                                  })}
                                </select>
                                <label className="large-label float-lb">
                                  Office Area/Sector <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 mt-4 float-field"
                                style={{ marginTop: "16px !important" }}>
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'office_address_same_as_registration', e)
                                  }} required>
                                  <option value="">Is Registered address same as
                                    Office address
                                  </option>
                                  <option
                                    value="Yes">Yes
                                  </option>
                                  <option
                                    value="No">No
                                  </option>

                                </select>
                                <label className="large-label float-lb">
                                  Is Registered address same as Office address
                                </label>
                              </div>

                              {inputList[0]['office_address_same_as_registration'] === 'No' &&
                                <>
                                  <SearchLocation
                                    handleCurrentLocationBlur={handleCurrentLocationBlur}
                                    isError={isInputError.crl}
                                    value={optOption.currentLocation}
                                    handleCurrentLocationChange={handleCurrentLocationChange}
                                    label={"Dealer Registration Location"}
                                    setPincodeValue={setPincodeValue}
                                  />
                                  <div className="col-md-6 float-field mt-3">
                                    <input type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                        setPincodeValue(value, 'pincode');
                                        setLocationSearchId('registration_address');
                                        e.target.value = value;
                                      }}
                                      value={pincodeValue}
                                      required
                                      maxLength={6}
                                      minLength={6}
                                      pattern="[0-9]*"
                                      inputMode="numeric"
                                    />

                                    <label className="large-label float-lb">
                                      Registration Pincode <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div className="col-md-6 float-field">
                                    <input type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(pincode?.geo_city_id, 'geo_city_id')
                                      }}
                                      disabled
                                      value={pincode?.city_name !== undefined ? pincode?.city_name : ''}
                                      required
                                    />

                                    <label className="large-label float-lb">
                                      Registration Geographical City <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div className="col-md-6 float-field">
                                    <input type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInput(pincode?.geo_state_id, 'geo_state_id')
                                      }}
                                      disabled
                                      value={pincode?.state_name !== undefined ? pincode?.state_name : ''}
                                      required
                                    />

                                    <label className="large-label float-lb">
                                      Registration Geographical State <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div
                                    className="col-sm-6 float-field mt-3">
                                    <select
                                      className="form-control form-control-user"
                                      onChange={(e) => {
                                        handleZone(e.target.value)
                                      }} required={true}>
                                      <option value="">Select City</option>
                                      {cities && cities.map((val) => {
                                        return (
                                          <option
                                            value={val?.id}>{val.name}</option>
                                        )
                                      })}
                                    </select>
                                    <label className="large-label float-lb">
                                      Registration City <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div
                                    className="col-sm-6 float-field mt-3">
                                    <select
                                      className="form-control form-control-user"
                                      onChange={(e) => handleArea(e.target.value)}
                                      required={true}>
                                      <option value="">Select Zone</option>
                                      {zones.map((val) => {
                                        return (
                                          <option
                                            value={val?.id}>{val.name}</option>
                                        )
                                      })}
                                    </select>
                                    <label className="large-label float-lb">
                                      Registration Zone <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div
                                    className="col-sm-6 float-field mt-3">
                                    <select
                                      className="form-control form-control-user"
                                      onChange={(e) => handleInput(e.target.value, 'area_id')}
                                      required={true}>
                                      <option value="">Select Area/Sector</option>
                                      {areas && areas.map((val) => {
                                        return (
                                          <option
                                            value={val?.id}>{val.name}</option>
                                        )
                                      })}
                                    </select>
                                    <label className="large-label float-lb">
                                      Registration Area/Sector <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>

                                </>
                              }
                              <div className="col-sm-6 mt-4 float-field"
                                style={{ marginTop: "16px !important" }}>
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'msme_certificate', e)
                                  }} required>
                                  <option value="">MSME Certificate</option>
                                  <option
                                    value="Yes">Yes
                                  </option>
                                  <option
                                    value="No">No
                                  </option>

                                </select>
                                <label className="large-label float-lb">
                                  MSME Certificate
                                </label>
                              </div>
                              {inputList[0]?.msme_certificate === 'Yes' &&
                                <div
                                  className="col-sm-6 col-md-6 mt-4 float-field">
                                  <input type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      handleInput(e.target.value, 'msme_no', e)
                                    }}
                                    required
                                  />
                                  <label
                                    className="large-label float-lb">
                                    MSME No <i
                                      className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                              }
                              <div
                                className="col-sm-6 col-md-6 mt-4 float-field">
                                <input type="email"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'registration_email', e)
                                  }}
                                  required
                                  value={inputList[0]?.registration_email}
                                />
                                <label
                                  className="large-label float-lb">
                                  Dealer Email Id <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>

                              <div
                                className="col-sm-6 col-md-6 mt-4 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'registration_phone_no', e)
                                  }}
                                  value={ucdDetails?.data && ucdDetails?.data?.registration_mobile_no ? ucdDetails?.data?.registration_mobile_no : inputList[0]['registration_phone_no']}
                                />
                                <label
                                  className="large-label float-lb">
                                  Registration Phone No <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 mt-3 float-field"
                                style={{ marginTop: "16px !important" }}>
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'bank_name')

                                  }} required={true}>
                                  <option value="">Bank Name
                                  </option>
                                  {newBankDetailsResponse.map(val => {
                                    return (
                                      <>
                                        <option
                                          value={val?.id}>{val?.id}</option>
                                      </>
                                    )
                                  })}

                                </select>
                                <label
                                  className="large-label float-lb">
                                  Bank Name <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              {inputList[0]['bank_name'] === 'Other' &&
                                <div
                                  className="col-sm-6 col-md-6 mt-3 float-field">
                                  <input type="text"
                                    className="form-control form-control-user"
                                    placeholder=" "
                                    onChange={(e) => {
                                      setCustomerBankName(e.target.value)
                                    }}
                                  />
                                  <label
                                    className="large-label float-lb">
                                    Bank Name
                                  </label>
                                </div>
                              }
                              {/*<div*/}
                              {/*    className="col-sm-6 col-md-3 mt-1 float-field">*/}
                              {/*    <input type="text"*/}
                              {/*           className="form-control form-control-user"*/}
                              {/*           placeholder=" "*/}
                              {/*           onChange={(e) => {*/}
                              {/*               handleInput(e.target.value, 'bank_name')*/}
                              {/*           }}*/}
                              {/*           required*/}
                              {/*    />*/}
                              {/*    <label*/}
                              {/*        className="large-label float-lb">*/}
                              {/*        Bank Name <i*/}
                              {/*        className="bi bi-asterisk astrick-icon"></i>*/}
                              {/*    </label>*/}
                              {/*</div>*/}

                              <div
                                className="col-sm-6 col-md-6 mt-3 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                    handleInput(e.target.value, 'account_no')
                                    e.target.value = value;
                                  }}
                                  required
                                />
                                <label
                                  className="large-label float-lb">
                                  Bank Account No <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 mt-3 float-field"
                                style={{ marginTop: "16px !important" }}>
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'account_type')
                                  }} required>
                                  <option value="">Account Type</option>
                                  <option
                                    value="Savings">Saving
                                  </option>
                                  <option
                                    value="Current">Current
                                  </option>

                                </select>
                                <label className="large-label float-lb">
                                  Account Type
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-3 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'ifsc_code')
                                  }}
                                  required
                                  maxLength={11}
                                  minLength={11}
                                />
                                <label
                                  className="large-label float-lb">
                                  IFSC Code <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div
                                className="col-sm-6 col-md-6 mt-1 float-field">
                                <input type="text"
                                  className="form-control form-control-user"
                                  placeholder=" "
                                  onChange={(e) => {
                                    handleInput(e.target.value, 'branch_name')
                                  }}
                                  required
                                />
                                <label
                                  className="large-label float-lb">
                                  Branch Name <i
                                    className="bi bi-asterisk astrick-icon"></i>
                                </label>
                              </div>
                              <div className="col-sm-6 mt-1 float-field"
                                style={{ marginTop: "16px !important" }}>
                                <select
                                  className="form-control form-control-user"
                                  onChange={(e) => {
                                    setAgreementType(e.target.value)
                                  }} required>
                                  <option value="">Account Type</option>
                                  <option
                                    value="1">Upload Agreement
                                  </option>
                                  <option
                                    value="2">E-Sign Agreement
                                  </option>

                                </select>
                                <label className="large-label float-lb">
                                  Agreement Type
                                </label>
                              </div>
                              {parseInt(agreementType) === 1 &&
                                <div className="col-sm-6 float-field mb-3">
                                  <FileUpload
                                    id={`addAttachment`}
                                    accept=".png,.jpg,.jpeg,.pdf,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                      handleInput(val, 'agreement_certificate')
                                    }}
                                    required={true}
                                    prefilledFilename={inputList[0]['agreement_certificate'] ? "Agreement Certificate" : ""}
                                  >
                                    Agreement Certificate
                                  </FileUpload>
                                </div>
                              }
                              {parseInt(agreementType) === 2 &&
                                <>
                                  <div
                                    className="col-sm-6 col-md-6 mt-1 float-field">
                                    <input type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        setPhoneNo(e.target.value)
                                      }}
                                      disabled={true}
                                      value={phoneNo}
                                    />
                                    <label
                                      className="large-label float-lb">
                                      Phone No
                                    </label>
                                  </div>
                                  {/*verifyText*/}
                                  <div className="col-md-12 d-flex">
                                    <a
                                      className={`${verifyText === 'Verified' ? "col-md-12" : "col-md-6"} btn btn-primary btn-user btn-block submit-btn mt-2 mr-2`}
                                      onClick={handleAgreementNotify}>
                                      Request for E-sign verify
                                    </a>

                                    {verifyText !== 'Verified' &&
                                      <a
                                        className="col-md-6 btn btn-primary btn-user btn-block submit-btn mt-2"
                                        onClick={handleIsAgreementEsigned}
                                      >
                                        {verifyText}
                                      </a>
                                    }
                                  </div>
                                </>
                              }

                              <div className="col-sm-6 float-field mt-2  mb-3">
                                <FileUpload
                                  id={`addAttachment`}
                                  accept=".png,.jpg,.jpeg,.pdf,.doc"
                                  documentUploadUrl={documentUploadUrlPublic}
                                  documentUrlData={documentUrlDataPublic}
                                  onChange={(val) => {
                                    handleInput(val, 'upload_cancelled_cheque')
                                  }}
                                  required={true}
                                  prefilledFilename={inputList[0]['upload_cancelled_cheque'] ? "Cancelled Cheque" : ""}
                                >
                                  <div className="d-flex">
                                    Upload Cancelled Cheque
                                    <div style={{ color: "darkred" }}>*</div>
                                  </div>
                                </FileUpload>
                              </div>
                              {ucdDetails?.data && ucdDetails?.data?.channel_type === 'DSA' ?
                                <div className="col-sm-6 float-field mb-3">
                                  <FileUpload
                                    id={`addAttachment`}
                                    accept=".png,.jpg,.jpeg,.pdf,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                      handleInput(val, 'selfie_with_dsa')
                                    }}
                                    required={true}
                                    prefilledFilename={inputList[0]['selfie_with_dsa'] ? "Selfie with DSA" : ""}
                                    multiple={true}
                                  >
                                    <div className="d-flex">
                                      Selfie with DSA
                                      <div style={{ color: "darkred" }}>*</div>
                                    </div>
                                  </FileUpload>
                                </div>
                                :
                                <>
                                  <div className='col-md-6 mb-4'>
                                    <span style={{fontWeight: "bold"}}>
                                      Dealership Images (Min. 4)
                                      <span style={{ color: "darkred" }}>*</span>
                                    </span>

                                    <div className="d-flex mt-3" style={{ gap: "10px" }}>
                                      {[1, 2, 3, 4].map((num) => (
                                        <NewFileUploader
                                          key={num}
                                          id={`dealer_images_${num}`}
                                          label={
                                                <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                  <i className="bi bi-upload"></i> {num}
                                                </span>
                                              }
                                          accept=".png,.jpg,.jpeg,.pdf,.doc"
                                          name={`dealer_images_${num}`}
                                          documentUploadUrl={documentUploadUrlPublic}
                                          documentUrlData={documentUrlDataPublic}
                                          onChange={(val) => {
                                            handleInput(val, `dealer_images_${num}`);
                                          }}
                                          value={inputList[0]?.[`dealer_images_${num}`]}
                                        />
                                      ))}

                                    </div>
                                  </div>
                                </>
                              }

                              {inputList[0]?.gst_registration === 'Yes' &&
                                <div className="col-sm-6 float-field mb-3">
                                  <FileUpload
                                    id={`addAttachment`}
                                    accept=".png,.jpg,.jpeg,.pdf,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                      handleInput(val, 'gst_certificate_photo')
                                    }}
                                    required={(ucdDetails?.data && ucdDetails?.data?.organization_type === 'Company') || inputList[0]?.gst_registration === 'Yes'}
                                    prefilledFilename={inputList[0]['gst_certificate_photo'] ? "GST Certificate" : ""}
                                  >
                                    <div className="d-flex">
                                      Upload GST Certificate
                                      <div style={{ color: "darkred" }}>*</div>
                                    </div>
                                  </FileUpload>
                                </div>
                              }

                              <div className="col-sm-6 float-field mb-3">
                                <FileUpload
                                  id={`addAttachment`}
                                  accept=".png,.jpg,.jpeg,.pdf,.doc"
                                  documentUploadUrl={documentUploadUrlPublic}
                                  documentUrlData={documentUrlDataPublic}
                                  onChange={(val) => {
                                    handleInput(val, 'pan_card_photo')
                                  }}
                                  required={true}
                                  prefilledFilename={inputList[0]['pan_card_photo'] ? "PAN Card" : ""}
                                >
                                  <div className="d-flex">
                                    Upload PAN Card
                                    <div style={{ color: "darkred" }}>*</div>
                                  </div>
                                </FileUpload>
                              </div>
                              {/*{(parseInt(userId) !== 886 || parseInt(userId) !== 876) &&*/}
                              {/*    <div className="col-sm-6 float-field mb-3">*/}
                              {/*        <FileUpload*/}
                              {/*            id={`addAttachment`}*/}
                              {/*            accept=".png,.jpg,.jpeg,.pdf,.doc"*/}
                              {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                              {/*            documentUrlData={documentUrlDataPublic}*/}
                              {/*            onChange={(val) => {*/}
                              {/*                handleInput(val, 'agreement_certificate')*/}
                              {/*            }}*/}
                              {/*            required={true}*/}
                              {/*            prefilledFilename={inputList[0]['agreement_certificate'] ? "Agreement Certificate" : ""}*/}
                              {/*        >*/}
                              {/*            Agreement Certificate*/}
                              {/*        </FileUpload>*/}
                              {/*    </div>*/}
                              {/*}*/}

                              {inputList[0]?.msme_certificate === 'Yes' ?
                                <div className="col-sm-6 float-field mb-3">
                                  <FileUpload
                                    id={`addAttachment`}
                                    accept=".png,.jpg,.jpeg,.pdf,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                      handleInput(val, 'msme_certificate_photo')
                                    }}
                                    required={true}
                                    prefilledFilename={inputList[0]['msme_certificate_photo'] ? "MSME Certificate" : ""}
                                  >
                                    <div className="d-flex">
                                      MSME Certificate
                                      <div style={{ color: "darkred" }}>*</div>
                                    </div>
                                  </FileUpload>
                                </div>
                                :
                                <div className="col-sm-6 float-field mb-3">
                                  <FileUpload
                                    id={`addAttachment`}
                                    accept=".png,.jpg,.jpeg,.pdf,.doc"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                      handleInput(val, 'msme_declaration_photo')
                                    }}
                                    required={true}
                                    prefilledFilename={inputList[0]['msme_declaration_photo'] ? "MSME Declaration" : ""}
                                  >
                                    MSME Declaration
                                  </FileUpload>
                                </div>
                              }


                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex">
                        <button className="btn btn-primary btn-user btn-block submit-btn"
                        // disabled={disableSubmitButton}
                        >
                          Submit Details
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <BottomMenu />
      </div>
    </>
  )
}

export default Save